import { ArrowRight, ShieldCheck, TrendingUp, MessageCircle } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1616805765352-beedbad46b2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwYnVzaW5lc3MlMjBvd25lciUyMG1vZGVybnxlbnwwfHx8fDE3ODE1NzQ1Mjl8MA&ixlib=rb-4.1.0&q=85";

function openChat() {
  window.dispatchEvent(new CustomEvent("seedtech:open-chat"));
}

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-cream bg-adinkra">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-20 sm:px-12 sm:py-28 lg:grid-cols-12 lg:py-32">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-umber/15 bg-white/70 px-3 py-1 text-xs uppercase tracking-[0.18em] text-umber">
            <span className="h-1.5 w-1.5 rounded-full bg-terracotta" />
            Built for African founders & SMEs
          </div>
          <h1
            data-testid="hero-headline"
            className="font-display text-5xl font-bold leading-[1.05] tracking-tight text-umber text-balance sm:text-6xl lg:text-7xl"
          >
            Win grants & VC funding —
            <span className="block italic text-terracotta">on international standards.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-umber/75">
            SeedTechNG prepares investor-grade <strong className="text-umber">financial models</strong>,{" "}
            <strong className="text-umber">data rooms</strong> and{" "}
            <strong className="text-umber">grant applications</strong> that help African businesses unlock funding from
            international VCs, foundations and development partners.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={openChat}
              className="group inline-flex items-center gap-2 rounded-md bg-terracotta px-6 py-3.5 text-sm font-medium text-cream shadow-lg shadow-terracotta/20 transition hover:-translate-y-0.5 hover:bg-terracotta-dark"
            >
              <MessageCircle className="h-4 w-4" />
              Talk to us
              <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
            </button>
            <a
              data-testid="hero-cta-secondary"
              href="#pricing"
              className="inline-flex items-center gap-2 rounded-md border border-umber/20 bg-white px-6 py-3.5 text-sm font-medium text-umber transition hover:border-umber"
            >
              See pricing
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-6 sm:grid-cols-3 max-w-xl">
            <Stat number="$48M+" label="raised by clients" />
            <Stat number="120+" label="businesses served" />
            <Stat number="14" label="African countries" />
          </div>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative">
            <img
              src={HERO_IMG}
              alt="African business owner"
              className="aspect-[4/5] w-full rounded-md object-cover shadow-xl"
            />
            <div className="absolute -bottom-6 -left-6 hidden rounded-md border border-border bg-white p-5 shadow-xl sm:block max-w-[240px]">
              <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-moss">
                <ShieldCheck className="h-4 w-4" /> VC-standard
              </div>
              <p className="mt-2 font-display text-base leading-snug text-umber">
                &ldquo;They closed our $1.2M seed in 11 weeks.&rdquo;
              </p>
              <p className="mt-2 text-[11px] text-umber/60">— Ada O., Lagos</p>
            </div>
            <div className="absolute -top-6 -right-4 hidden rounded-md bg-umber p-4 text-cream shadow-xl sm:block">
              <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gold">
                <TrendingUp className="h-3.5 w-3.5" /> Funding secured
              </div>
              <p className="mt-1 font-display text-2xl">94%</p>
              <p className="text-[10px] text-cream/60">application success rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display text-3xl font-semibold text-umber">{number}</div>
      <div className="text-[11px] uppercase tracking-[0.15em] text-umber/60">{label}</div>
    </div>
  );
}
